fx.ns("repositories", class BackgroundDefaultRepository extends fx.ModelArray {

    constructor()
    {
        super([]);

        this.endpoint = "/app/backgrounds";
    }

    load()
    {
        this.post(  { 
            action:"defaults",
        }, 
        this._loaded);
    }

    _loaded(data)
    {
        if (data.error)
        //this.event("server-error", data);
        this.event("load-backgrounds-error", data);
        else
        {
            if (data.length > 0)
                this.addItem(data, false);

            this.event("default-backgrounds-loaded", data);
        }
    }

    add(background, themetag)
    {
        let obj = this.find({theme_background_id : background.id, theme_tag_id : themetag.id});
        if (!obj)
            this.addItem( new models.ThemeBackgroundTag({theme_background_id : background.id, theme_tag_id : themetag.id}) );
    }

    remove(background, themetag)
    {
        let obj = this.find({theme_background_id : background.id, theme_tag_id : themetag.id});
        if (obj)
        {
            this.removeItem(obj);
            obj.delete();
        }
    }
});
